export default __webpack_public_path__ + "static/media/Elza Maria de Jesus.b272ddfc.png";